export class TargetAudienceRow {
  inviteSent: boolean;

  constructor(
    public emailAddress: string,
    public name: string
  ) {}
}
